// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50fa5f04","732":"62214763","977":"0ad53fb1"}[chunkId] + ".chunk.js";
};